import { Injectable, inject } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from '../../../environments/environment';
import { ApiService } from './api.service';

@Injectable()
export class StoreIdentifierPharmacyPartnerMappingsService extends ApiService {
  private http = inject(HttpClient);


  getDistinctNames(): Observable<string[]> {
    return this.http.get<string[]>(`${environment.captureApi.url}/store_identifier_pharmacy_partner_mappings/names`);
  }
}
